import React from 'react'
import PropTypes from "prop-types";
import { displayNumbers } from '../../../variables/numbersFunctions';
import { Table } from 'antd';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import entete from "../../../assets/img/entete.jpg"
import { frenchDateOnly } from '../../../variables/functions';

const GeneratedBordereauCommissions = (props) => {
    const MyFooter = () => {
        const primeNette = props.emissions.reduce((pn, commission) => pn + commission.montant, 0);
        const totalCommission = props.emissions.reduce((pn, commission) => pn + commission.commission, 0);

        return (
            <div className='row'>
                <div className='col-6'>
                    <b>Total primes</b>:{" "}
                    {displayNumbers(primeNette)} F CFA
                </div>
                <div className='col-6'>
                    <b>Total commissions</b>:{" "}
                    {displayNumbers(totalCommission)} F CFA
                </div>
            </div>
        );
    };

    const columns = [
        {
            title: "Police",
            dataIndex: "numeroPoliceP",
            key: "numeroPoliceP",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.numeroPolice}</p>
            ),
            width: 100
        },
        {
            title: "Avenant",
            dataIndex: "numeroPoliceP",
            key: "numeroPoliceP",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.avenant}</p>
            ),
            width: 15
        },
        {
            title: "Assuré",
            dataIndex: "assure",
            key: "assure",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.nomSouscripteur} {record.prenomSouscripteur}</p>
            ),
            width: 150
        },
        {
            title: "Effet",
            dataIndex: "dateEffet",
            key: "dateEffet",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record?.dateEffet ? frenchDateOnly(record?.dateEffet) : "-"} </p>
            ),
            width: 50
        },

        {
            title: "Echéance",
            dataIndex: "dateEcheance",
            key: "dateEcheance",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record?.dateEcheance ? frenchDateOnly(record?.dateEcheance) : "-"} </p>
            ),
            width: 50
        },
        {
            title: "Catégorie",
            dataIndex: "categorie",
            key: "categorie",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{record.categorie}</p>
            ),
            width: 30
        },
        {
            title: "PN Pool",
            dataIndex: "primeNette",
            key: "primeNette",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.montant)} </p>
            ),
            width: 80
        },
        {
            title: "PN Cie",
            dataIndex: "primeNette",
            key: "primeNette",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.montant)} </p>
            ),
            width: 80
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
            render: (_, record) => (
                <p style={{ width: "70%" }}>{displayNumbers(record?.accessoires)} </p>
            ),
            width: 10
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.taxes)} </p>
            ),
            width: 10
        },
        {
            title: "Taux de commission",
            dataIndex: "tauxCommission",
            key: "tauxCommission",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.tauxCommission)}  %</p>
            ),
            width: 10
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
            render: (_, record) => (
                <p style={{ width: "100%" }}>{displayNumbers(record.commission ? record.commission : (record.montant * record.tauxCommission / 100))} </p>
            ),
            width: 90
        },
    ];

    return (
        <div class="row">
            <div class="col-12">
                <div className="page-2">
                    <img
                        src={entete}
                        alt="Header"
                        style={{
                            width: "1155px",
                            height: "125px"
                        }}
                    />
                    <div class="card testimonial-card" style={{ width: "1155px" }}>
                        <div class="text-center">
                            <h5><u>Bordereau des commissions</u></h5>
                        </div>
                        <div class="row">
                            <div className="col-lg-12">
                                {/* <div className="container"> */}
                                <Table
                                    style={{ width: "1155px" }}
                                    columns={columns}
                                    dataSource={props?.emissions}
                                    pagination={false}
                                    size='small'
                                    bordered
                                    className="custom-table"
                                    footer={() => <MyFooter />}
                                />
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                    <DocumentFooter />
                </div>
            </div>
        </div>
    )
}
GeneratedBordereauCommissions.propTypes = {
    emissions: PropTypes.array,
    agence: PropTypes.object,
}

export default GeneratedBordereauCommissions